
export default function letter( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_LETTER':
			return action.letter
		case 'GET_USER_LET':
			return action.letter
		case 'GET_LETTER':
			return action.letter
		case 'DELETE_LETTER':
			return action.letter
		case 'BLOCK_LETTER':
			return action.letter
		case 'UPDATE_LETTER':
			return action.letter
		case 'UPDATE_REQUEST_FOR':
			return action.letter
		case 'UPDATE_ADDRESS':
			return action.letter
		case 'UPDATE_PURPOSE':
			return action.letter
		case 'UPDATE_REMARKS':
			return action.letter
		case 'UPDATE_DATE':
			return action.letter
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/letter/letter.reduce.js